let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4MuPR")).then(() => parcelRequire('kpPkX'));